import { useForm, Head } from "@inertiajs/react";

import Button from "/components/Button";
import TextField from "/components/TextField";
import DropZone from "/components/DropZone";
import TextArea from "/components/TextArea";

import Layout from "/AdminLayout";
import { useToast } from "/utils/toast-context.jsx";

const PublicPagesEdit = ({
  public_page,
}) => {

  const { data, setData, put, transform, errors } = useForm(public_page);
  const { successToast } = useToast();

  const onSubmit = (state, preview = false) => {
    transform((data) => ({
      ...data,
      state: state,
      preview: preview,
    }));
    put(
      `/admin/public_pages/${public_page.codename}`,
      {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    )
  };

  const setImage = (key, value) => {
    if (value) {
      setData(key, value);
      setData(`remove_${key}`, 0);
    } else {
      setData(key, {});
      setData(`remove_${key}`, 1);
    }
  };

  return (
    <>
      <Head>
        <title>Редактирование страницы</title>
      </Head>

      <div className="frm-wrapper">
        <form className="frm">
          <ActionsBar onSubmit={onSubmit} public_page={public_page} />

          <div className="inpt-line">
            <TextField
              label="Заголовок страницы"
              value={data.title_ru}
              onChange={value => setData("title_ru", value)}
              errors={errors.title_ru}
            />

            <TextField
              label="Page header"
              value={data.title_en}
              onChange={value => setData("title_en", value)}
              errors={errors.title_en}
            />
          </div>

          {public_page.has_content && (
            <>
              <div className="inpt-line">
                <TextField
                  label="Сообщение по центру страницы"
                  value={data.content_ru}
                  onChange={value => setData("content_ru", value)}
                  errors={errors.content_ru}
                />

                <TextField
                  label="Page centered message"
                  value={data.content_en}
                  onChange={value => setData("content_en", value)}
                  errors={errors.content_en}
                />
              </div>

              <div className="inpt-line">
                <TextField
                  label="Ссылка для сообщения по центру страницы"
                  value={data.content_link}
                  onChange={value => setData("content_link", value)}
                  errors={errors.content_link}
                />
              </div>
            </>
          )}

          <div className="inpt-line">
            <div className="frm frm--small">
              <DropZone
                label="Привью для шеринга 1200x630"
                className="project-preview-dropzone"
                value={data.og_image_ru}
                onChange={value => setImage("og_image_ru", value)}
              />

              <TextField
                label="Заголовок для шеринга"
                placeholder="Студия Пууул"
                value={data.og_title_ru}
                onChange={value => setData("og_title_ru", value)}
              />

              <TextArea
                label="Текст для шеринга"
                placeholder="Введите краткий текст для шеринга, чтобы оно занимало 2-3 предложения"
                value={data.og_description_ru}
                onChange={value => setData("og_description_ru", value)}
              />
            </div>

            <div className="frm frm--small">
              <DropZone
                label="Preview for sharing 1200x630"
                className="project-preview-dropzone"
                value={data.og_image_en}
                onChange={value => setImage("og_image_en", value)}
              />

              <TextField
                label="Title for sharing"
                placeholder="Poool Studio"
                value={data.og_title_en}
                onChange={value => setData("og_title_en", value)}
              />

              <TextArea
                label="Description for sharing"
                placeholder="Please provide a brief project description that is 2-3 sentences long"
                value={data.og_description_en}
                onChange={value => setData("og_description_en", value)}
              />
            </div>
          </div>

          <ActionsBar onSubmit={onSubmit} public_page={public_page} />
        </form>
      </div>
    </>
  );
}

function ActionsBar({
  onSubmit,
  public_page,
}) {
  return (
    <div className="actions-bar">
      <div>
        <Button onClick={() => onSubmit("change")} className="lnk lnk--green">Сохранить</Button>
        <Button onClick={() => onSubmit("publish")} className="lnk lnk--blue">Сохранить и опубликовать</Button>
        {public_page.has_content && (
          <Button onClick={() => onSubmit("change", true)} className="lnk">Превью</Button>
        )}
      </div>

      <div>
        <a href="/admin/projects" className="lnk">Отмена</a>
      </div>
    </div>
  );
}

PublicPagesEdit.layout = (page) => <Layout children={page} />;

export default PublicPagesEdit;
